module.exports = __webpack_public_path__ + "static/img/bg32.3e847a86.png";